<template>
  <div class="allocation-rule-wrap">
    <div class="table-wrap">
      <div class="table-header">
        <span class="header-name">批量规则</span>
        <span class="count-text"
          >已添加账户数量：<span class="count-num">{{ adCount_len }}</span></span
        >
        <el-button type="text" class="edit-btn" @click="showDialog = true"
          ><svg-icon iconClass="edit" className="icon"></svg-icon>编辑</el-button
        >
      </div>
      <div class="header-table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" width="150" label="属性"> </el-table-column>
          <el-table-column prop="num" label="数量"> </el-table-column>
          <el-table-column prop="rule" label="拆分规则"> </el-table-column>
        </el-table>
      </div>
      <div class="header-table-footer">
        预计在<span class="count-num">{{ adCount_len }}</span
        >个账户的 <span class="count-num">{{ planNum }}</span
        >个计划创建 <span class="count-num">{{ groupNum }}</span
        >个广告组
      </div>
    </div>

    <el-dialog title="分配规则" :visible.sync="showDialog" width="500px" :close-on-click-modal="false" top="8vh">
      <div class="dialog-body">
        <ul class="rule-list">
          <li class="rule-item">
            <span class="rule-label">定向包：</span>
            <el-radio-group v-model="formData.targeting" @change="changeRules('targeting')">
              <el-radio label="adset" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="campaign" :disabled="disableGroup">广告计划</el-radio>
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意组：</span>
            <el-radio-group v-model="formData.creativeGroups" @change="changeRules('creativeGroups')">
              <el-radio label="adset" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="campaign" :disabled="disableGroup">广告计划</el-radio>
            </el-radio-group>
          </li>
          <li class="rule-item">
            <span class="rule-label">创意标题：</span>
            <el-radio-group v-model="formData.textGroups" @change="changeRules('textGroups')">
              <el-radio label="adset" :disabled="disableGroup">广告组</el-radio>
              <el-radio label="campaign" :disabled="disableGroup">广告计划</el-radio>
            </el-radio-group>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  components: {
    SvgIcon,
  },
  data() {
    return {
      showDialog: false,
      formData: {
        targeting: "adset",
        creativeGroups: "adset",
        textGroups: "adset",
      },
      groupNum: 0,
      planNum: 0,
      timer: null,
      disableGroup: false,
    };
  },
  methods: {
    changeRules(key) {
      this.$store.commit("set_split_rule_gdt", {
        key: key,
        value: this.formData[key],
      });
      this.computedPlan();
    },
    computedPlan() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        let groupNum = 1;
        let planNum = 1;
        let numObj = {
          targeting: this.dxb_len,
          creativeGroups: this.cyz_len,
          textGroups: this.cybt_len,
        };
        for (let [key, value] of Object.entries(this.formData)) {
          if (value === "adset") {
            //广告组
            groupNum *= numObj[key];
          } else if (value === "campaign") {
            //广告计划
            planNum *= numObj[key];
          }
        }
        this.groupNum = this.adCount_len * groupNum;
        this.planNum = this.adCount_len * planNum;
      }, 300);
    },
  },
  computed: {
    ...mapState({
      split_rule: (state) => state.PromotionGdt.split_rule,
      draft_campaign: (state) => state.PromotionGdt.draft_campaign,
      campaignMode: (state) => state.PromotionGdt.draft_campaign.campaignMode,
      adCount_len: (state) => (state.PromotionGdt.adCount || []).length,
      dxb_len: (state) => {
        let list = state.PromotionGdt.draft_targeting;
        return (state.PromotionGdt.adCount || []).length > 0 ? list.length || 1 : 0;
      },
      cyz_len: (state) => {
        let list = state.PromotionGdt.draft_creative.creativeGroups;
        return (state.PromotionGdt.adCount || []).length > 0 ? list.length : 0;
      },
      cybt_len: (state) => {
        let list = state.PromotionGdt.draft_creative.textGroups;
        return (state.PromotionGdt.adCount || []).length > 0 ? list.length : 0;
      },
    }),
    tableData() {
      return [
        {
          name: "定向包",
          num: this.dxb_len,
          rule: this.formData.targeting === "campaign" ? "广告计划" : this.formData.targeting === "adset" ? "广告组" : "排序分配",
        },
        {
          name: "创意组",
          num: this.cyz_len,
          rule: this.formData.creativeGroups === "campaign" ? "广告计划" : this.formData.creativeGroups === "adset" ? "广告组" : "排序分配",
        },
        {
          name: "创意标题",
          num: this.cybt_len,
          rule: this.formData.textGroups === "campaign" ? "广告计划" : this.formData.textGroups === "adset" ? "广告组" : "排序分配",
        },
      ];
    },
  },
  watch: {
    split_rule: {
      handler(value) {
        if (value) {
          let copyData = JSON.parse(JSON.stringify(value));
          this.formData = copyData;
        }
      },
      deep: true,
    },
    draft_campaign(value) {
      if (value && value.online_campaign) {
        //已有广告组
        this.formData.targeting === "adset" && (this.formData.targeting = "campaign");
        this.formData.creativeGroups === "adset" && (this.formData.creativeGroups = "campaign");
        this.formData.textGroups === "adset" && (this.formData.textGroups = "campaign");
        this.$store.commit("set_allsplit_rule_gdt", this.formData);
      }
    },
    campaignMode(value) {
      if (value === "edit") {
        this.formData.targeting = "adset";
        this.formData.textGroups = "adset";
        this.formData.creativeGroups = "adset";
        this.disableGroup = true;
      } else {
        this.disableGroup = false;
      }
    },
    adCount_len() {
      this.computedPlan();
    },
    dxb_len() {
      this.computedPlan();
    },
    cyz_len() {
      this.computedPlan();
    },
    cybt_len() {
      this.computedPlan();
    },
  },
};
</script>

<style lang="less" scoped>
.allocation-rule-wrap {
  .table-wrap {
    width: 100%;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    box-sizing: border-box;
    .table-header {
      display: flex;
      align-items: flex-end;
      .header-name {
        color: rgba(0, 0, 0, 1);
        font-weight: 500;
        font-size: 16px;
        font-weight: bold;
      }
      .count-text {
        color: rgba(0, 0, 0, 0.45);
        font-size: 12px;
        line-height: 15px;
        margin-left: 12px;
        .count-num {
          color: rgba(24, 144, 255, 1);
          font-size: 14px;
        }
      }
      .edit-btn {
        margin-left: auto;
        color: rgba(24, 144, 255, 1);
        padding: 0px;
        .icon {
          margin-right: 4px;
        }
      }
    }
    .header-table-wrap {
      margin-top: 24px;
    }
    .header-table-footer {
      padding: 16px 0;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      .count-num {
        margin: 0 4px;
        color: rgba(24, 144, 255, 1);
        font-size: 14px;
      }
    }
  }
  .dialog-body {
    .rule-list {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .rule-item {
        margin-top: 20px;
        .rule-label {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          text-align: right;
          padding-right: 2px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
